<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'list-item'">
    <div class="list-item">
      <div class="details">
        <div class="icon-name">
          <rt-icon
            name="attach-file"
            margin-right-small-xx
            colorToken="colorIconLowDefault"
          ></rt-icon>
          <a *ngIf="isDocumentOrImage" class="link" (click)="open()">{{ attachment.filename }}</a>
          <a
            *ngIf="!isDocumentOrImage"
            class="link"
            [href]="attachment.fileUrl"
            (click)="onAnchorClick($event)"
            >{{ attachment.filename }}</a
          >
          <span text-light *ngIf="attachment.fileSize" class="size"
            >({{ attachment.fileSize | rtFileSize }})</span
          >
        </div>
        <rt-icon-button
          *ngIf="hasDeleteAction"
          variant="plain"
          (click)="delete()"
          size="small"
          class="danger-on-hover"
          shape="square"
          iconName="delete"
        >
        </rt-icon-button>
      </div>
      <rt-divider variant="line dark" margin-top-small> </rt-divider>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'card'">
    <div
      class="rt-card"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="preview"></ng-container>
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'compact-card'">
    <div
      class="rt-card rt-card-background-light attachment-small"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="preview"></ng-container>
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'tile'">
    <div
      class="rt-card rt-card-background-light attachment-small-x"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'preview'">
    <div
      class="rt-card rt-card-background-light attachment-small"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="preview"></ng-container>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'preview-large'">
    <div
      class="rt-card attachment-large"
      [class.additional-opts-visible]="additionalOptsDropdownOpen"
      [class.private]="isPrivate"
    >
      <ng-container *ngTemplateOutlet="preview"></ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #preview>
  <div class="preview">
    <ng-container *ngIf="imageLoading">
      <rt-spinner></rt-spinner>
    </ng-container>
    <ng-container *ngIf="!imageLoading">
      <img *ngIf="hasThumbnail" [src]="thumbnailUrl" (error)="thumbnailLoadError()" />
      <ng-container
        *ngIf="!hasThumbnail && emptyStateTemplate"
        [ngTemplateOutlet]="emptyStateTemplate"
      >
      </ng-container>
      <div *ngIf="!hasThumbnail && !emptyStateTemplate" class="extension">
        <div class="extension__oval">
          <div text-uppercase text-weight-semi-bold class="extension__name">
            {{ attachment.extension }}
          </div>
        </div>
      </div>
    </ng-container>
    <div class="overlay">
      <div class="overlay__inner">
        <div *ngIf="actions.length" class="actions">
          <ng-container *ngIf="actions.length === 1; else multiActions">
            <rt-icon-button
              [ngClass]="actions[0].variant || {}"
              [rtTooltip]="actions[0].label | translate"
              (click)="actions[0].handler()"
              variant="plain-onoverlay"
              shape="square"
              [size]="type === 'compact-card' ? 'small' : 'medium'"
              [iconName]="actions[0].icon"
              class="delete-button"
            >
            </rt-icon-button>
          </ng-container>
          <ng-template #multiActions>
            <rt-icon-button
              size="small"
              shape="square"
              iconName="more-horiz"
              variant="plain-onoverlay"
              #additionalOptsTrigger="rtOverlayOrigin"
              rt-overlay-origin
              (click)="toggleAdditionalOptsDropdown(true, $event)"
              [pressed]="additionalOptsDropdownOpen"
            >
            </rt-icon-button>

            <ng-template
              #additionalOpts="rtConnectedOverlay"
              rt-connected-overlay
              [hasBackdrop]="true"
              [offsetX]="-5"
              [origin]="additionalOptsTrigger"
              [open]="additionalOptsDropdownOpen"
              (backdropClick)="toggleAdditionalOptsDropdown(false)"
            >
              <rt-dropdown (click)="$event.preventDefault()">
                <rt-dropdown-item
                  *ngFor="let action of actions; trackBy: trackByLabel"
                  (click)="action.handler()"
                >
                  <rt-icon prefix [name]="action.icon"></rt-icon>
                  {{ action.label | translate }}
                </rt-dropdown-item>
              </rt-dropdown>
            </ng-template>
          </ng-template>
        </div>

        <div *ngIf="isDocumentOrImage" (click)="open()" class="open-preview-layer">
          <rt-icon name="visibility" size="medium" colorToken="colorIconOnoverlayDefault">
          </rt-icon>
        </div>

        <a
          rt-button
          *ngIf="!isDocumentOrImage && hasDownloadAction"
          [class.small]="type === 'compact-card'"
          [href]="href"
          download
          (click)="onAnchorClick($event)"
          variant="primary"
        >
          <rt-icon name="file-download" size="medium"> </rt-icon>
          <span>{{ translations.previewDialog.downloadFile | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footer>
  <div class="footer">
    <span *ngIf="!hasDownloadAction" text-bold>{{ attachment.filename }}</span>
    <div *ngIf="hasDownloadAction" class="details">
      <rt-icon name="attach-file" *ngIf="type === 'tile'"> </rt-icon>
      <ng-container *ngIf="isPrivate">
        <rt-icon
          [rtTooltip]="'rtu.attachment.private_file_tooltip' | translate"
          [rtTooltipMaxWidth]="200"
          name="lock"
        >
        </rt-icon>
      </ng-container>
      <rt-truncate>
        <ng-container *ngIf="attachment.filename">
          <div *ngIf="!highlightedFilename && isDocumentOrImage" class="name" (click)="open()">
            {{ attachment.filename }}
          </div>
          <div
            *ngIf="highlightedFilename && isDocumentOrImage"
            [innerHtml]="highlightedFilename"
            (click)="open()"
            class="name name--highlighted"
          ></div>
          <a
            *ngIf="!highlightedFilename && !isDocumentOrImage"
            href="{{ attachment.fileUrl }}"
            class="name"
            (click)="onAnchorClick($event)"
            download
          >
            {{ attachment.filename }}
          </a>
          <a
            *ngIf="highlightedFilename && !isDocumentOrImage"
            href="{{ attachment.fileUrl }}"
            [innerHtml]="highlightedFilename"
            class="name name--highlighted"
            (click)="onAnchorClick($event)"
            download
          >
          </a>
        </ng-container>
      </rt-truncate>

      <div *ngIf="footerIcon || moreTemplate" layout-horizontal>
        <div *ngIf="footerIcon" class="footer__icon-wrap">
          <rt-icon [name]="footerIcon"></rt-icon>
        </div>
        <div *ngIf="moreTemplate">
          <rt-icon-button
            size="small"
            iconName="more-horiz"
            shape="square"
            #moreDropdownOrigin="rtOverlayOrigin"
            [pressed]="moreDropdown.open"
            rt-overlay-origin
            variant="plain"
            (click)="moreDropdown.open = !moreDropdown.open"
          >
          </rt-icon-button>

          <ng-template
            #moreDropdown="rtConnectedOverlay"
            rt-connected-overlay
            [hasBackdrop]="true"
            [origin]="moreDropdownOrigin"
            (backdropClick)="moreDropdown.open = false"
          >
            <ng-template
              [ngTemplateOutlet]="moreTemplate"
              [ngTemplateOutletContext]="{ attachmentAssignment: attachmentAssignment }"
            >
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="user" *ngIf="hasUploader && type === 'card'">
      <rt-avatar
        [type]="avatarData.hasAvatar ? 'image' : 'initials'"
        [size]="'small'"
        [shape]="'oval'"
        [imageSrc]="avatarData.photoThumbUrl"
        [initials]="avatarData.initials"
        [context]="avatarData.context"
      ></rt-avatar>
      <div layout-vertical>
        <div layout>
          <div class="user-name" text-weight-semi-bold>{{ uploaderName }}</div>
          <rt-badge
            *ngIf="attachment.guestId"
            color="optional"
            [text]="'app.common.guest' | translate"
            margin-left-small-x
          >
          </rt-badge>
        </div>
        <rt-date [time]="attachment.createdAt"> </rt-date>
      </div>
    </div>
  </div>
</ng-template>
